import { For, Show } from "solid-js";
import type { RecentEvent } from "../../lib/sse/event-store";

export type { RecentEvent as EventRow };

interface Props {
    events: RecentEvent[];
}

export function EventLog(props: Props) {
    return (
        <div class="border rounded p-4 mt-4">
            <strong>Events (ultimos 20)</strong>
            <Show when={props.events.length > 0} fallback={<div class="text-gray-500 mt-2">Nenhum evento.</div>}>
                <ul class="mt-2 space-y-1 font-mono text-xs">
                    <For each={props.events}>
                        {(e) => (
                            <li>
                                <span class="text-gray-500">{e.received_at}</span>{" "}
                                <span class="text-blue-700">{e.event_type}</span>{" "}
                                <span class="text-gray-700">{JSON.stringify(e.payload)}</span>
                            </li>
                        )}
                    </For>
                </ul>
            </Show>
        </div>
    );
}
